import { constants } from "@thecb/components";
import styled from "styled-components";

const TableWrapper = styled.div`
  width: auto;
  border-radius: 4px;
  box-shadow: 0px 0px 5px rgba(202, 206, 216, 1);
  background-color: ${constants.colors.WHITE};
`;

export default TableWrapper;
